export default __webpack_public_path__ + "static/media/Location_permission.ad63607e.svg";